<template>
  <b-overlay
    variant="white"
    :show="isLoadingFiles"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
  <div
      id="dashboard"
      class="row"
  >
    <div class="col-12 mb-2">
      <FilesFilters
          v-if="!isAguasAndinas"
          :value="filters"
          :onChange="onChangeFilters"
          :clear="clearFilters"
          :default-date="defaultDateRange"
      />

      <Filters
          v-if="isAguasAndinas"
          @on-server-filters-change="onChangeFilters"
          :default-date="defaultDateRange"
      />
    </div>
    <div class="col-12 col-md-8">
      <div class="col">
        <BarFilesByState
            ref="by-state-and-date"
            id="by-state-and-date"
            @selected-card="handleSelectedCard"
        />
      </div>
    </div>
    <div class="col-12 col-md-4">
      <DonutsFilesByCreationState
          ref="by-state"
          id="by-state"
          @selected-card="handleSelectedCard"
      />
    </div>
  </div>
  <div
      class="row"
      v-if="isAguasAndinas"
  >
    <div class="col-12 col-md-3">
      <VencidoEnXDias
          ref="by-expirations-1"
          id="by-expirations-1"
          v-bind:class="{'bg-gray': selectedCard === 'by-expirations-1'}"
          :from="1"
          :to="90"
          @selected-card="handleSelectedCard"
      />
    </div>
    <div class="col-12 col-md-3">
      <VencenEnXDias
          ref="by-expirations-2"
          id="by-expirations-2"
          v-bind:class="{'bg-gray': selectedCard === 'by-expirations-2'}"
          :from="0"
          :to="7"
          @selected-card="handleSelectedCard"
      />
    </div>
    <div class="col-12 col-md-3">
      <VencenEnXDias
          ref="by-expirations-3"
          id="by-expirations-3"
          v-bind:class="{'bg-gray': selectedCard === 'by-expirations-3'}"
          :from="8"
          :to="15"
          @selected-card="handleSelectedCard"
      />
    </div>
    <div class="col-12 col-md-3">
      <VencenEnXDias
          ref="by-expirations-4"
          id="by-expirations-4"
          v-bind:class="{'bg-gray': selectedCard === 'by-expirations-4'}"
          :from="15"
          :to="30"
          @selected-card="handleSelectedCard"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-12 mt-2">
      <b-card
          style="min-height: 182px;"
          class="card-congratulation-medal"
      >

        <FilesHeader
            :exportable="!this.isExportingFiles && true"
            @export-list="exportList"
        />
        <feather-icon
            icon="SettingsIcon"
            size="15"
            class="spinner margin-auto"
            v-if="isLoadingFiles"
        />
        <FileRow
            :id="'file-row-' + file.febosId"
            :ref="'file-row-' + file.febosId"
            :key="file.febosId"
            v-for="file in files"
            :file="file"
            :on-general-files="true"
            :select-file="selectFile"
        >
          <template
              slot="actions"
              slot-scope="file"
          >
            <FileOptions
                :ref="'file-options-' + file.febosId"
                :file="file.file"
                :select-file="selectFile"
            >
              <!-- Define actions            -->
              <template
                  slot="action-list"
              >
                <span></span>
              </template>
            </FileOptions>
          </template>
        </FileRow>
      </b-card>
      <FilesPagination
          :show="files.length"
          v-model="page"
      />
    </div>
    <PopUpGeneralDetailFile
        @reload="reload"
        :file="selectedFile"
    />
    <PopUpBinnacleFile
        @reload="reload"
        :file="selectedFile"
    />
    <PopUpParticipantsFile
        @reload="reload"
        :file="selectedFile"
    />
    <PopUpTimelineFile
        @reload="reload"
        :file="selectedFile"
    />
    <PopUpReferencesFile
        @reload="reload"
        :file="selectedFile"
    />
    <PopUpTicketFile
        @reload="reload"
        :file="selectedFile"
    />
  </div>
  </b-overlay>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import FilesPagination from '@/febos/chile/dnt/components/files/FilesPagination';
import DonutsFilesByCreationState from '@/febos/chile/dnt/components/dashboard/DonutsFilesByCreationState';
import Filters from '@/febos/chile/dnt/components/dashboard/Filters';
import VencenEnXDias from '@/febos/chile/dnt/components/dashboard/VencenEnXDias';
import VencidoEnXDias from '@/febos/chile/dnt/components/dashboard/VencidoEnXDias';
import BarFilesByState from '@/febos/chile/dnt/components/dashboard/BarFilesByState';
import FilesFilters from '@/febos/chile/dnt/components/files/FilesFilters';
import FilesHeader from '@/febos/chile/dnt/components/files/FilesHeader';
import FileRow from '@/febos/chile/dnt/components/files/FileRow';
import FileOptions from '@/febos/chile/dnt/components/files/FileOptions';
import PopUpGeneralDetailFile from '@/febos/chile/dnt/vistas/modals/PopUpGeneralDetailFile';
import PopUpBinnacleFile from '@/febos/chile/dnt/vistas/modals/PopUpBinnacleFile';
import PopUpParticipantsFile from '@/febos/chile/dnt/vistas/modals/PopUpParticipantsFile';
import PopUpTimelineFile from '@/febos/chile/dnt/vistas/modals/PopUpTimelineFile';
import PopUpReferencesFile from '@/febos/chile/dnt/vistas/modals/PopUpReferencesFile';
import PopUpTicketFile from '@/febos/chile/dnt/vistas/modals/PopUpTicketFile';
import { DATE_RANGE_LAST_3_MONTH } from '@/febos/chile/commons/dateCommons';
import { queueTask, verifyQueueTask } from '@/febos/servicios/api/herramientas.api';

export default {
  name: 'Dashboard',
  components: {
    Filters,
    PopUpGeneralDetailFile,
    PopUpBinnacleFile,
    PopUpParticipantsFile,
    PopUpTimelineFile,
    PopUpReferencesFile,
    PopUpTicketFile,
    FilesHeader,
    FileRow,
    FileOptions,
    FilesFilters,
    FilesPagination,
    DonutsFilesByCreationState,
    BarFilesByState,
    VencenEnXDias,
    VencidoEnXDias
  },
  data() {
    const { view } = this.$route.params;
    return {
      view,
      defaultDateRange: DATE_RANGE_LAST_3_MONTH,
      selectedCard: null,
      selectedCardFilters: null,
      isLoadingFiles: false,
      isExportingFiles: false,
      showLoading: false,
      selectedFile: {},
      textSearch: '',
      filters: '',
      page: Number.parseInt(this.$route.query.page || 1, 10),
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10)
    };
  },
  computed: {
    ...mapGetters('Dnts', [
      'loading',
      'loadingBinnacle',
      'error',
      'successAction',
      'files',
      'pagination'
    ]),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Usuario', ['currentUserId']),
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    }
  },
  watch: {
    loading(value) {
      this.loader(value);
    },
    loadingBinnacle(value) {
      this.loader(value);
    },
    showLoading(value) {
      this.loader(value);
    },
    async page(page) {
      this.showLoading = true;
      updateSearchParams({ page });
      await this.loadDocumentList(this.getBaseFilters());
      this.showLoading = false;
    }
  },
  methods: {
    ...mapActions([
      'setApiError'
    ]),
    ...mapActions('Dnts', [
      'listDocuments',
      'clearErrorMessage',
      'selectFileState'
    ]),
    loader(value) {
      if (this.isLoadingFiles) return;

      if (value) {
        this.$vs.loading({
          container: '#app',
          scale: 0.6
        });
      } else {
        this.$vs.loading.close('#app > .con-vs-loading');
      }
    },
    async handleSelectedCard({ id, filters }) {
      if (this.selectedCard === id) {
        this.selectedCard = null;
        this.selectedCardFilters = null;
      } else {
        this.selectedCard = id;
        this.selectedCardFilters = filters;
      }
      if (this.page === 1) {
        this.showLoading = true;
        await this.loadDocumentList(this.getBaseFilters());
        this.showLoading = false;
      } else {
        this.page = 1;
      }
    },
    async reload() {
      await this.fetchDocuments();
    },
    selectFile(file) {
      this.selectedFile = file;
      this.selectFileState(file.febosId);
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchDocuments();
        }
      }
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('febosId')) { return this.$route.query.filters; }
      }
      return mergeFilters(this.$route.query.filters, this.filters);
    },
    safeLoadIndicator(name, filter) {
      if (this.$refs[name]) this.$refs[name].loadIndicator(filter);
    },
    ejecutarFiltrosGraficos(filter) {
      const filterGraficos = filter.replace('general:0', '').replace('||', '|');
      try {
        this.safeLoadIndicator('by-state', filterGraficos);
        this.safeLoadIndicator('by-state-and-date', filterGraficos);
        this.safeLoadIndicator('by-expirations-1', filterGraficos);
        this.safeLoadIndicator('by-expirations-2', filterGraficos);
        this.safeLoadIndicator('by-expirations-3', filterGraficos);
        this.safeLoadIndicator('by-expirations-4', filterGraficos);
      } catch (e) {
        console.error('error cargando un indicador', e);
      }
    },
    getBaseFilters() {
      const filtroContent = this.textSearch !== '' ? `|content$${this.textSearch}` : '';
      const filtersGeneral = `emisorRut:${this.company.iut}|tipo:EXP|${this.getFilters()}${filtroContent}`;
      const filtersMine = `emisorRut:${this.company.iut}|tipo:EXP|destinoResponsableIds:${this.currentUserId}|${this.getFilters()}${filtroContent}`;
      return this.view === 'my-files' ? filtersMine : filtersGeneral;
    },
    async exportList() {
      try {
        this.isExportingFiles = true;
        const filter = this.getBaseFilters();
        const llamada = {
          handler: 'funcion_lambda.febos.funciones.opensearch.buscar.handler',
          indice: 'expedientes',
          aplicacion: 'ED',
          campos: '*',
          elementosPorPagina: '10000',
          filtros: filter + (this.selectedCardFilters ? `|${this.selectedCardFilters}` : ''),
          formato: 'csv',
          orden: '-fechaCreacion',
          pagina: '1',
          tipo: 'EXP',
          pais: 'cl',
        };

        this.$bvToast.toast(
          'Preparando los datos solicitados',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const task = await queueTask({
          proceso: 'py_febos_core_reportes',
          ejecutarDeInmediato: 'si'
        }, btoa(unescape(encodeURIComponent(JSON.stringify(llamada)))));
        setTimeout(() => {
          this.verifyTask(task.data.tareaId);
        }, 1000);
      } catch (error) {
        console.error(error);
        this.isExportingFiles = false;
      }
    },
    async verifyTask(taskId, callBack) {
      const response = await verifyQueueTask(taskId);
      try {
        switch (response.data.estado) {
          case 0: // Esta creada y aun no iniciado
          case 1: // Esta creada y aun no iniciado
          case 2:
            setTimeout(() => {
              this.verifyTask(taskId, callBack);
            }, 3000);
            break;
          case 3:
            if (response.data.avance > 100) {
              await this.verifyTask(taskId, callBack);
            } else if (response.data.resultado) {
              const fetchedJson = await fetch(response.data.resultado);
              const jsonResponse = await fetchedJson.json();
              window.open(jsonResponse.url, '_blank');
              this.$bvToast.toast(
                'Archivo generado',
                {
                  title: 'Listo!',
                  variant: 'primary',
                  pauseOnHover: true,
                  solid: true,
                  autoHideDelay: 2000
                }
              );
              this.isExportingFiles = false;
            }
            break;
          case 4:
            await this.setApiError({
              codigo: 10,
              duracion: response.data.duracion,
              fecha: response.data.fecha,
              mensaje: 'Ha ocurrido un error en la generación del Pdf, por favor intenta con imágenes o elementos no tan grandes',
              seguimientoId: response.data.seguimientoId
            });
            this.saving = false;
            if (response.data.avance > 100) {
              await this.setApiError({
                codigo: 10,
                duracion: response.data.duracion,
                fecha: response.data.fecha,
                mensaje: 'Ha ocurrido un error en la generación del Pdf, por favor intenta con imágenes o elementos no tan grandes',
                seguimientoId: response.data.seguimientoId
              });
              this.saving = false;
            }
            break;
          default:
            console.log('default');
            break;
        }
      } catch (error) {
        console.log('ERROR', error);
      }
    },
    async loadDocumentList(filter) {
      this.isLoadingFiles = true;
      const query = {
        params: {
          tipo: 'EXP',
          campos: '*',
          pagina: this.page,
          orden: '-fechaCreacion',
          elementosPorPagina: this.rowspp,
          filtros: filter + (this.selectedCardFilters ? `|${this.selectedCardFilters}` : '')
        }
      };
      await this.listDocuments(query);
      this.isLoadingFiles = false;
    },
    async fetchDocuments() {
      this.debounceFetchDocuments();
    },
    debounceFetchDocuments: _.debounce(async function debounceFetchDocuments() {
      const filter = this.getBaseFilters();
      this.ejecutarFiltrosGraficos(filter);
      await this.loadDocumentList(filter);
    }, 350)
  },
  mounted() {
    this.fetchDocuments();
  }
};
</script>

<style scoped>

</style>
